<div *ngIf="reactiveFormGroup$ | async" [formGroup]="reactiveFormGroupComponent?.getReactiveFormGroup()">
  <ng-container *ngIf="!clearable || !selectedEmployer">
    <app-odata-typeahead-search
      [odataFunction]="odataFunction"
      [placeHolder]="placeholder"
      [disabled]="!!selectedEmployer"
      label="Employer"
      i18n-label
      [hideLabel]="true"
      [displayValueInline]="true"
      [customItemTemplate]="lookAheadItemTemplate"
      [popperClass]="'look-ahead-popper-full-width'"
      [hasErrors]="hasErrors$ | async"
      (lookAheadCleared)="employerSelected.emit(undefined)"
      (lookAheadSelected)="employerSelected.emit($event)" />
  </ng-container>
  <ng-container *ngIf="clearable && selectedEmployer">
    <form class="search-bar-container">
      <div class="selected-employer">
        <input
          [value]="selectedEmployer.name + ' (' + selectedEmployer.id + ')'"
          class="text-field search-text-field"
          id="searchBar"
          name="searchBar"
          readonly="readonly"
          autocomplete="off"
          type="text" />
        <div class="clear-button" (click)="employerSelected.emit(null)">
          <img [src]="'assets/icons/dark/X.svg'" alt="pill-icon" i18n-alt />
        </div>
      </div>
    </form>
  </ng-container>
  <lib-reactive-form-general-error
    [parentFormGroupComponent]="reactiveFormGroupComponent"
    [reactiveFormItemComponent]="this"
    [required]="required"
    [disabled]="disableInput$ | async"
    [performValidationWhenDisabled]="performValidationWhenDisabled"
    (hasError)="connectToHasErrors($event)" />
  <input hidden [formControlName]="inputName" [id]="id" [name]="inputName" />
</div>

<ng-template #lookAheadItemTemplate let-employer>{{ employer.name }} ({{ employer.id }})</ng-template>
